import { EFlags } from '@feathr/blackbox';

export function flagLabels(flag: EFlags): string {
  const labels: Record<EFlags, string> = {
    [EFlags.aiGroupBuilder]: 'Show AI Group Builder',
    [EFlags.bypassMX]: 'Bypass MX',
    [EFlags.creditCardConvenienceFeeAccepted]: 'Credit Card Convenience Fee Accepted',
    [EFlags.csmManager]: 'CSM Manager',
    [EFlags.enforceOnboarding]: 'Enforce Onboarding',
    [EFlags.hasBlackbaudRaisersEdge]: 'Has Blackbaud Raisers Edge',
    [EFlags.hasGoogleAds]: 'Has Google Ads',
    [EFlags.hasImis]: 'Has IMIS',
    [EFlags.hasMultiConversions]: 'Has Multi Conversions',
    [EFlags.hasSavedGeoFilterSets]: 'Has Saved Geo Filter Sets',
    [EFlags.locales]: 'Locales',
    [EFlags.metaIntegrationOutage]: 'Meta Integration Outage',
    [EFlags.metaV2]: 'Meta V2',
    [EFlags.minBudget]: 'Min Budget',
    [EFlags.monetization]: 'Monetization',
    [EFlags.noMaxBudget]: 'No Max Budget',
    [EFlags.overridePackageImplementationsAccess]: 'Override Implementations Access',
    [EFlags.pinpointSendAllEmails]: 'Pinpoint Send All Emails',
    [EFlags.pinpoint]: 'Pinpoint',
    [EFlags.showAllAffinityAudiences]: 'Show All Affinity Audiences',
    [EFlags.showCampaignRecommendations]: 'Show Campaign Recommendations',
    [EFlags.showCommandPalette]: 'Show Command Palette',
    [EFlags.showConversionsSettingsV2]: 'Show Conversions Settings V2',
    [EFlags.showDripBulkEnroll]: 'Show Drip Bulk Enroll',
    [EFlags.showDripCampaigns]: 'Show Drip Campaigns',
    [EFlags.showForms]: 'Show Forms',
    [EFlags.showFundraiseCRM]: 'Show Fundraising CRM',
    [EFlags.showFundraise]: 'Show Fundraising',
    [EFlags.showGoalsV2]: 'Show Goals 2.0',
    [EFlags.showGrowthCredits]: 'Show Growth Credits',
    [EFlags.showNewPrimaryNav]: 'Show New Primary Nav',
    [EFlags.showOnboarding]: 'Show Onboarding',
    [EFlags.showProResources]: 'Show Pro Resources',
    [EFlags.showUsageMetrics]: 'Show Usage Metrics',
    [EFlags.showUsersAndRolesV2]: 'Show Users and Roles V2',
    [EFlags.useContactLimits]: 'Use Contact Limits',
    [EFlags.useEmailLimits]: 'Use Email Limits',
    [EFlags.zapier]: 'Zapier',
  };
  return labels[flag];
}
